import React, { createContext, useContext, useEffect, useState } from 'react'

const MenuContext = createContext()

export const MenuProvider = ({ children, location }) => {
  const [menuMainShow, setMenuMainShow] = useState(false)

  const handleMainMenu = () => {
    setMenuMainShow(!menuMainShow)
    if (menuMainShow) {
      document.querySelector('body').classList.remove('scroll-menu')
    }
    if (typeof window !== 'undefined') {
      if (window.innerWidth <= 1100) {
        if (!menuMainShow) {
          document.querySelector('body').classList.add('no-scroll-mobile')
        } else {
          document.querySelector('body').classList.remove('no-scroll-mobile')
        }
      }
    }
  }

  useEffect(() => {
    setMenuMainShow(false)
    document.querySelector('body').classList.remove('no-scroll-mobile')
  }, [])

  return (
    <MenuContext.Provider value={{ menuMainShow, handleMainMenu, location }}>
      {children}
    </MenuContext.Provider>
  )
}

export function useMenuContext() {
  return useContext(MenuContext)
}
